import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { ApiKey } from '../../../../../typings/ApiKey.interface';
import Text from '../common/base/Text';
import { useDialog } from '../common/Dialog';
import SelectInput from '../common/Form/Fields/SelectInput';
import { Div } from '../common/helpers/StyledUtils';
import { useToasts } from '../common/Toast';
import { GlobalContext } from '../contexts/GlobalContext';
import ConfirmDeleteDialog from '../scenes/DashboardScene/Connections/ConfirmDeleteDialog';
const delay_options = [{
  label: 'now',
  value: '0'
}, {
  label: 'in 1 hour',
  value: '3600'
}, {
  label: 'in 24 hours',
  value: '86400'
}];
const roll_form_props = {
  validate: (values: {
    delay_sec?: string;
  }) => {
    if (!values.delay_sec) {
      return {
        delay_sec: 'Required'
      };
    }
    return {};
  },
  Fields: () => <Div flex={{
    justify: 'space-between',
    align: 'center'
  }} m={{
    t: 6,
    b: 4
  }}>
      <Text bold>Key expiration</Text>
      <SelectInput block name="delay_sec" placeholder={'Select...'} required m={0} w={{
      px: 140
    }} options={delay_options} />
    </Div>
};
const getDelayLabel = (delay_sec: number): string | undefined => {
  return delay_options.find(option => option.value === delay_sec.toString())?.label.replace('in ', '');
};
interface UseApiKeyActionsParams {
  // The settings page acting on the keys: organization settings manage every key of the
  // organization (admins only), project settings only the current project's keys.
  managed_from: 'organization' | 'project';
  onRolled?: (api_key: ApiKey) => void;
  onDeleted?: (id: string) => void;
}
export function useApiKeyActions(t0) {
  const $ = _c(17);
  const {
    managed_from,
    onRolled,
    onDeleted
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const api = managed_from === "organization" ? HookdeckAPI.organizations : HookdeckAPI.teams;
  let t1;
  if ($[0] !== addToast || $[1] !== api || $[2] !== onRolled) {
    t1 = (api_key, delay_sec) => {
      api.rollApiKey(api_key.id, {
        delay_sec
      }).then(res => {
        onRolled?.(res);
      }).catch(() => {
        addToast("error", "Failed to roll API key");
      });
    };
    $[0] = addToast;
    $[1] = api;
    $[2] = onRolled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const rollApiKey = t1;
  let t2;
  if ($[4] !== rollApiKey || $[5] !== showDialog) {
    t2 = api_key_0 => {
      showDialog(values => rollApiKey(api_key_0, parseInt(values.delay_sec, 10)), _temp, {
        title: "Roll API Key",
        message: "By rolling your API Key, your current key will no longer be authorized to make requests to our API. We will generate a new key for you to use. If you select a rollover period below, both your old and new API key will be authorized for the remainder of the window.",
        submit_label: "Roll API Key",
        danger: true,
        cancel_label: "Cancel",
        form_props: roll_form_props
      });
    };
    $[4] = rollApiKey;
    $[5] = showDialog;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleRollApiKey = t2;
  let t3;
  if ($[7] !== addToast || $[8] !== api || $[9] !== onDeleted) {
    t3 = api_key_1 => {
      api.deleteApiKey(api_key_1.id).then(t4 => {
        const {
          id
        } = t4;
        addToast("success", "API key deleted");
        onDeleted?.(id);
      }).catch(() => {
        addToast("error", "Failed to delete API key");
      });
    };
    $[7] = addToast;
    $[8] = api;
    $[9] = onDeleted;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const deleteApiKey = t3;
  let t4;
  if ($[11] !== deleteApiKey || $[12] !== showDialog) {
    t4 = api_key_2 => {
      showDialog(() => deleteApiKey(api_key_2), _temp2, {
        title: "Delete API Key",
        submit_label: "Delete",
        cancel_label: "Cancel",
        danger: true,
        submit_icon: "delete",
        message: <ConfirmDeleteDialog text="This API key will be permanently revoked and can no longer be used to access the API." />
      });
    };
    $[11] = deleteApiKey;
    $[12] = showDialog;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleDeleteApiKey = t4;
  let t5;
  if ($[14] !== handleDeleteApiKey || $[15] !== handleRollApiKey) {
    t5 = {
      handleRollApiKey,
      handleDeleteApiKey
    };
    $[14] = handleDeleteApiKey;
    $[15] = handleRollApiKey;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp2() {
  return null;
}
function _temp() {
  return null;
}